import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { SelectDropdown } from '@adsk/bim360-matrix-react-components';
import { issueAttributesType, oxygenType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import { STATUS_DRAFT } from '../../../../../../../constants/status-types';
import { getUsersList } from '../../../../../../../utils/assigned-to-helpers';
import { HQ_USER_TYPE } from '../../../../../../../constants/hq-types';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';
import FilterSearchIcon from '../../../../../../FilterSearchIcon';
import { getUserCompanyName } from '../../../../../../../utils/userHelpers';

class UserOnlyAssignedToInlineEdit extends PureComponent {

  render() {
    const { issue, oxygen, className, styleType } = this.props;
    const assignedToUsersList = getUsersList(issue.currentAllowedAssignees, oxygen);
    const assignedToOptions = issue.assignedToType === HQ_USER_TYPE && assignedToUsersList.length === 0 && oxygen.users[issue.assignedTo] ? [oxygen.users[issue.assignedTo]] : assignedToUsersList;
    // TODO - this is a temp fix in the client until the BE fixes BTLV-4225
    const canEditAssignedTo = issue.status !== STATUS_DRAFT;

    return (
      <IssueFieldInlineEdit
        issue={issue}
        disabled={!canEditAssignedTo}
        className={className}
        data-testid={this.props['data-testid']}
        attributeName={ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO}
        label={T.translate('assignment.to')}
        getDisplayValue={currentValue => {
          if (currentValue) {
            const selectedUserEntity = oxygen.users[currentValue];
            if (selectedUserEntity) {
              return selectedUserEntity.name;
            }
          }
          // Fallback for backward compatibility for RFIs without assignedTo value.
          return issue.currentAssignee || '';
        }}
        placeholder={T.translate('assignment.assigneeUnspecified')}
        styleType={styleType}
      >
        {(currentValue, closeEditMode, updateIssue) => <SelectDropdown
          selectedOptions={(assignedToOptions || []).find(user => user && user.oxygenId === currentValue)}
          labelKey="name"
          valueKey="oxygenId"
          subtextGetter={getUserCompanyName}
          autofocus
          openOnFocus
          backspaceRemoves={false}
          options={assignedToOptions}
          searchable
          searchIcon={<FilterSearchIcon />}
          onClose={closeEditMode}
          onChange={(option) => {
            updateIssue(option.oxygenId);
          }}
        />}
      </IssueFieldInlineEdit>
    );
  }
}

UserOnlyAssignedToInlineEdit.displayName = 'UserOnlyAssignedToInlineEdit';

UserOnlyAssignedToInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  oxygen: oxygenType.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
};

export default UserOnlyAssignedToInlineEdit;
